import { useMutation } from "@tanstack/react-query";

import { updateShowGallery } from "@/api/headlinr";

interface useUpdateEventGalleryProps {
  onError: (error: any) => void;
  onSuccess: (data: any) => Promise<void>;
}
const useUpdateShowGallery = ({
  onError,
  onSuccess,
}: useUpdateEventGalleryProps) => {
  return useMutation({
    mutationFn: ({ id, published }: { id: number; published: boolean }) => {
      return updateShowGallery(id, published);
    },
    onError: (error) => {
      onError(error);
    },
    onSuccess: async (data) => {
      await onSuccess(data);
    },
  });
};

export default useUpdateShowGallery;
